<template>
  <div class="row">
    <div class="col-md-6">
      <el-form ref="form" :model="form" label-width="140px">
        <el-form-item label="TH Name">
          <el-input v-model="form.thName" name="thName" v-validate="'required'" clearable></el-input>
          <span class="el-form-item__error">{{ errors.first('thName') }}</span>
        </el-form-item>

        <el-form-item label="EN Name">
          <el-input v-model="form.enName" name="enName" v-validate="'required'" clearable></el-input>
          <span class="el-form-item__error">{{ errors.first('enName') }}</span>
        </el-form-item>

        <el-form-item label="TH Full Name">
          <el-input v-model="form.thFullName" name="thFullName" v-validate="'required'" clearable></el-input>
          <span class="el-form-item__error">{{ errors.first('thFullName') }}</span>
        </el-form-item>

        <el-form-item label="EN Full Name">
          <el-input v-model="form.enFullName" name="enFullName" v-validate="'required'" clearable></el-input>
          <span class="el-form-item__error">{{ errors.first('enFullName') }}</span>
        </el-form-item>

        <el-form-item label="Web Hook URL">
          <el-input v-model="form.webhook" name="webhook" clearable></el-input>
        </el-form-item>

        <el-form-item label="Address">
          <el-input
            type="textarea"
            :autosize="{ minRows: 2, maxRows: 4}"
            placeholder="Address"
            v-model="form.address">
          </el-input>
        </el-form-item>

        <el-form-item label="Description">
          <el-input
            type="textarea"
            :autosize="{ minRows: 2, maxRows: 4}"
            placeholder="Description"
            v-model="form.description">
          </el-input>
        </el-form-item>

        <el-form-item>
          <el-button type="primary" @click="onSubmit">Create</el-button>
          <el-button @click="reset">Cancel</el-button>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>


<script>
import Vue from "vue"
import { Autocomplete } from "element-ui"
import * as _apiCustomer from "@/api/customer"

Vue.use(Autocomplete)

export default {
  data() {
    return {
      inputSearch: '',
      form: {
        thName: '',
        enName: '',
        thFullName: '',
        enFullName: '',
        webhook: '',
        address: '',
        description: ''
      },
      isSearchFound: true,
    }
  },
  watch: {
  },
  methods: {
    onSubmit () {
      this.$validator.validateAll().then((result) => {
        console.log(result)
        if (result) {
          this.create()
          // this.$notify({
          //   message: 'XXX',
          //   type: 'success'
          // })
        } else {
          this.$notify({
          message: 'Please enter all required information',
            type: 'danger'
          })
        }
        //
      }).catch(() => {
        this.$notify({
          message: 'Please enter all required information',
          type: 'danger'
        })
      })
    },
    create () {
      _apiCustomer.create(this.form)
        .then(response => {
          this.$router.push(`/customers/${response.data}`)
          this.$notify({
            message: 'Save Successfully',
            type: 'success'
          })
          this.reset()
        })
        .catch(error => {
          this.$notify({
            message: error.response.data.message || 'Unsuccessfully',
            type: 'danger'
          })
        });
    },
    reset () {
      this.form.thName = ''
      this.form.enName = ''
      this.form.thFullName = ''
      this.form.enFullName = ''
      this.form.webhook = ''
      this.form.address = ''
      this.form.description = ''
      this.$validator.reset()
      // console.log(this.errors.clear())
    },
  }
}
</script>
